import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';


import PageTitle from 'components/PageTitle';
import Button from 'components/Button';
import { setStorage } from 'utilz';
import { URLS } from 'config';

import containerActions from './actions';

import './styles.scss';

class ConfirmationPage extends React.Component {
  disagreeHandl = type => () => {
    this.props.confirmationChangeHandl(false);

    this.props.confirmationSend(() => {
      if (!type) {
        this.props.workingChangeHandl(type);
        setStorage({
          working: {
            working: type
          }
        });
      }

      setStorage({
        confirmation: {
          confirmation: false
        }
      });

      this.props.history.push(type ? URLS.UPLOAD : `${URLS.DOWNPAYMENTS}`);
    });
  }

  render() {
    return (
      <div className="page-cofirm -not-full">
        <PageTitle>
			Could you confirm your monthly <span> income? </span>
        </PageTitle>
        <p className="cofirm">
			Confirming monthly income means submitting copy of your most recent paystub
        </p>
        <Button
          onClick={this.disagreeHandl(true)}
          disabled={false}
        >
			Yes
        </Button>
        <Button
          onClick={this.disagreeHandl(false)}
          disabled={false}
        >
			No
        </Button>
      </div>
    );
  }
}

ConfirmationPage.propTypes = {
  workingChangeHandl: PropTypes.func.isRequired,
  // eslint-disable-next-line
  history: PropTypes.object.isRequired,
  confirmationSend: PropTypes.func.isRequired,
  confirmationChangeHandl: PropTypes.func.isRequired
};

export default connect(null, containerActions)(ConfirmationPage);



// WEBPACK FOOTER //
// ./src/pages/Confirmation/index.js